<template>
  <el-dialog
    :title="setName + '- 参评社会组织管理'"
    :visible.sync="orgDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="1000px"
    center>
    <el-checkbox-group v-model="chioseOrgList">
      <el-row :gutter="20">
        <el-col :span="8" v-for="item in orgList" :key="item.id" class="margin-bottom-sm">
          <div>
            <el-checkbox :label="item.id">{{ item.title }}</el-checkbox>
          </div>
        </el-col>
      </el-row>
    </el-checkbox-group>

    <div class="flex align-center justify-around">
      <el-button class="padding-lr-xl" @click="resetForm()">取消</el-button>
      <el-button class="padding-lr-xl" type="primary" @click="submitForm()">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>


import {getExpertOrgList, saveExpertOrgList} from "@/api/admin";

export default {
  name: "expertChioseOrg",
  props: {
    orgDialog: {
      type: Boolean,
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setName: {
      type: String,
      default() {
        return '';
      }
    },
  },
  data() {
    return {
      orgList: [],
      chioseOrgList: [],
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },

  },
  created() {
    this.getOrgList()
  },
  methods: {
    async submitForm() {
      const res = await saveExpertOrgList(this.setId, this.chioseOrgList.join(','))
      if (res.status === 200) {
        this.$message.success('保存成功')
        this.$emit('cancelDialog')
      }
    },
    resetForm() {
      this.$emit('cancelDialog')
    },
    //  获取当前专家可选择的机构
    async getOrgList() {
      const res = await getExpertOrgList(this.$route.params.id, this.setId)
      this.orgList = res.data
      this.orgList.map(item=>{
        if(item.is_true === 1) this.chioseOrgList.push(item.id)
      })
    }
  },
  watch: {
    orgDialog() {
      if (!this.orgDialog) {
        this.orgList = []
        this.chioseOrgList = []
      }else{
        this.orgList = []
        this.chioseOrgList = []
        this.getOrgList()
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
